module.exports = __webpack_public_path__ + "img/silver.7c563729.svg";